import React from 'react';

const WeekProgress = ({ temaActual, vueltasCompletadas }) => {
  return (
    <div className="week-progress">
      <h4>Vuelta al temario (6 semanas)</h4>
      <div className="week-circles">
        {[1, 2, 3, 4, 5, 6].map(week => (
          <div 
            key={week} 
            className={`week-circle ${week === temaActual ? 'active' : ''} ${week < temaActual ? 'completed' : ''}`}
          >
            {week === temaActual ? (
              <span className="current-week">{week}</span>
            ) : week < temaActual ? (
              <i className="fas fa-check-circle completed-icon"></i>
            ) : (
              week
            )}
          </div>
        ))}
      </div>
      <p className="week-progress-info">
        Estás en la semana {temaActual} - Vuelta al temario #{vueltasCompletadas + 1} - Vueltas completadas: {vueltasCompletadas}
      </p>
    </div>
  );
};

export default WeekProgress;